module.exports = __webpack_public_path__ + "img/logo_no_text.dd08b8ac.svg";